<template>

    <section class="single-content container">


        <div class="infobox" v-if="info" :style="{ boxShadow: 'inset 30px 0 0 ' + color }">

            <h2 v-if="header">{{ header }}</h2>

            <slot></slot>

        </div>


    <!-- ///////// -->

        <div class="single-description" v-else>

            <h2 v-if="header">{{ header }}</h2>

            <slot></slot>

        </div>

    </section>

</template>

<script>
import { EventBus } from '@/main'
export default {

    props: {
        header: {
            type: String
        },
        info: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: '#3d3d3d'
        }
    }

}
</script>



// WEBPACK FOOTER //
// single-section.vue?97141ac0